import {
  Box,
  Button,
  HStack,
  IconButton,
  Stack,
  VStack,
} from "@chakra-ui/react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useFieldArray, useFormContext } from "react-hook-form";
import { MdClose } from "react-icons/md";
import DragIndicator from "../../../../components/common/Draggable/DragIndicator";
import { DraggableItem } from "../../../../components/common/Draggable/DraggableItem";
import { InputField } from "../../../../components/fields/InputField";
import { NumberField } from "../../../../components/fields/NumberField";
import QuestionTypeSelector from "../QuestionTypeSelector";

const LinearScaleQuestion = ({ questionIndex, onChange }) => {
  const { control, getValues } = useFormContext();
  const {
    fields: choices,
    append: appendChoice,
    remove: removeChoice,
    move: moveChoice,
  } = useFieldArray({
    control,
    name: "element.choices",
  });

  return (
    <DndProvider backend={HTML5Backend}>
      <VStack w={"100%"} spacing={6}>
        <Stack
          w={"100%"}
          gap={4}
          spacing={0}
          flexDirection={{ base: "column", md: "row" }}
        >
          <InputField
            field={{
              id: `prompt`,
              placeholder: "Provide your question prompt",
              validation: {
                required: { value: true, message: "Prompt is required" },
              },
            }}
          />
          <QuestionTypeSelector
            questionIndex={questionIndex}
            onChange={onChange}
          />
        </Stack>
        {choices.map((choice, index) => (
          <DraggableItem
            key={choice.id}
            id={choice.id}
            index={index}
            moveItem={(dragIndex, hoverIndex) => {
              moveChoice(dragIndex, hoverIndex);
              onChange();
            }}
            setDrag={(drag) => {
              const dragHandle = document.getElementById(
                `drag-handle-${choice.id}`
              );
              if (dragHandle) {
                drag(dragHandle);
              }
            }}
            styleProps={{
              w: "100%",
            }}
          >
            {() => {
              return (
                <HStack key={choice.id} w={"100%"} className="draggableThing">
                  <DragIndicator id={choice.id} width={"15px"} />

                  <Box w={"70px"}>
                    <NumberField
                      field={{
                        id: `element.choices[${index}].value`,
                        validation: {
                          required: {
                            value: true,
                            message: "Number is required",
                          },
                        },
                      }}
                    />
                  </Box>
                  <InputField
                    field={{
                      id: `element.choices[${index}].label`,
                      //placeholder: `Option ${index + 1}`,
                    }}
                    inputStyle={{ variant: "flushed" }}
                  />
                  {choices.length > 1 && (
                    <IconButton
                      icon={<MdClose />}
                      variant="ghost"
                      fontSize={"xl"}
                      onClick={() => {
                        removeChoice(index);
                        onChange();
                      }}
                    />
                  )}
                </HStack>
              );
            }}
          </DraggableItem>
        ))}
        <HStack w={"100%"}>
          <Box w={"15px"} />
          <Button
            onClick={() => {
              const lastNumberValue = getValues(
                `element.choices[${choices.length - 1}].value`
              );
              appendChoice({
                label: "",
                value: lastNumberValue
                  ? lastNumberValue + 1
                  : choices.length + 1,
              });
              onChange();
            }}
            alignSelf={"flex-start"}
          >
            Add Option
          </Button>
        </HStack>
      </VStack>
    </DndProvider>
  );
};

export default LinearScaleQuestion;
